<script lang="ts">
	//Design system components
	import { Text, Container, ControlsContainer } from '@Shelly/shelly-design-system';
	//Components
	import TimePickerWrapper from '../../../../../components/TimePicker/TimePickerWrapper.svelte';
	import TypeSelector from '../../SchedulesHelpers/TypeSelector.svelte';
	//Services
	import { format } from 'svelte-i18n';
	// Helpers
	import { modeTypes } from '../../SchedulesHelpers/schedules';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let editableObject;

	let time = editableObject.time;
	let hoursRange = editableObject.hoursRange;
	let type = editableObject.type;

	const changeTime = (e) => {
		time = e.detail;
		editableObject.time = time;
	};

	const changeMode = (e) => {
		type = e.detail;
		editableObject.type = type;
		hoursRange = e.detail !== modeTypes.time ? [0, 12] : [0, 23];
		editableObject.hoursRange = hoursRange;
	};
</script>

<Container class="mb-s" padding="scrollPaddings">
	<Text class="mb-l" element="h2">{$format('choose_time_interval')}</Text>

	<TypeSelector mode={type} on:change={changeMode} />

	<ControlsContainer color={$showNewLayout ? 'color-0' : undefined}>
		<TimePickerWrapper
			slot="first"
			{hoursRange}
			{time}
			mode={type}
			on:change={changeTime}
			on:change-mode={changeMode}
		/>
	</ControlsContainer>
</Container>
